var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearchTypeIcon),expression:"showSearchTypeIcon"}],staticClass:"search-type-icon",attrs:{"icon":_vm.searchTypeIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }